<template>
    <div class="progress-table">
        <div class="mb10">财产险维护审批</div>
        <div class="mb10">
            <span class="mr50">分公司：{{ info.companyName }}</span>
            <span class="mr50">经营中心：{{ info.businessName }}</span>
            <span>财产险数量：{{ info.bxCostCount }}</span>
        </div>
        <div class="mb10">财产险明细</div>
        <el-table v-loading="loading" border :data="tableData" style="width: 100%" max-height="200">
            <el-table-column
                sortable
                show-overflow-tooltip
                prop="bpCustomerName"
                label="订单客户"
                width="180"></el-table-column>
            <el-table-column
                sortable
                show-overflow-tooltip
                prop="bpSetcustomerName"
                label="结算客户"
                width="180"></el-table-column>
            <el-table-column
                sortable
                show-overflow-tooltip
                prop="bpCustomerType_"
                label="订单客户性质"
                width="180"></el-table-column>
            <el-table-column
                sortable
                show-overflow-tooltip
                prop="bpCustomerCategory_"
                label="客户类别"
                width="100"></el-table-column>
            <el-table-column sortable show-overflow-tooltip prop="bpStatus_" label="状态" width="100"></el-table-column>
            <el-table-column sortable show-overflow-tooltip prop="bpDate" label="月份" width="100"></el-table-column>
            <el-table-column
                sortable
                show-overflow-tooltip
                prop="companyName"
                label="分公司"
                width="180"></el-table-column>
            <el-table-column
                sortable
                show-overflow-tooltip
                prop="siteName"
                label="服务平台"
                width="180"></el-table-column>
            <el-table-column
                sortable
                show-overflow-tooltip
                prop="bpCargo"
                label="保险金额(元)"
                width="180"></el-table-column>
            <el-table-column
                sortable
                show-overflow-tooltip
                prop="bpRiskMoney"
                label="保险费(元)"
                width="180"></el-table-column>
            <el-table-column
                sortable
                show-overflow-tooltip
                prop="bpGoodsType"
                label="货物类别"
                width="180"></el-table-column>
            <el-table-column
                sortable
                show-overflow-tooltip
                prop="professionalCompany_"
                label="专业公司"
                width="180"></el-table-column>
            <el-table-column
                sortable
                show-overflow-tooltip
                prop="bpAddress"
                label="标的地址"
                width="180"></el-table-column>
            <el-table-column
                sortable
                show-overflow-tooltip
                prop="orderBusinessType_"
                label="业务场景"
                width="180"></el-table-column>
            <el-table-column
                sortable
                show-overflow-tooltip
                prop="createUserName"
                label="创建人"
                width="100"></el-table-column>
            <el-table-column
                sortable
                show-overflow-tooltip
                prop="createTime"
                label="创建时间"
                width="180"></el-table-column>
        </el-table>
        <el-pagination
            style="text-align: right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
    </div>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api'
import {
    insuranceBxCostsApprovalInfo,
    insuranceBxCostsApprovalPage,
} from '../../../../api/insurance/propertyInsrMaintn.js'
export default {
    props: ['fdId'],
    data() {
        return {
            dict: {},
            tableData: [],
            loading: false,
            pageNo: 1,
            pageSize: 10,
            total: 0,
            info: {},
        }
    },
    mounted() {
        dictWithUrl(
            'SRM_INSURANCE_IN_OR_OUT_CUSTOMER,SRM_INSURANCE_COUSTOMER_CATEGORY,SRM_INSURANCE_BP_STATUS,SYS_BUSINESS_CATEGORY,SYS_PROFESSIONAL_COMPANY',
        ).then(res => {
            if (res && +res.code === 0) {
                this.dict = res.data
                this.getInfo()
                this.getList()
            }
        })
    },
    methods: {
        handleSizeChange(v) {
            this.pageSize = v
            this.pageNo = 1
            this.getList()
        },
        handleCurrentChange(v) {
            this.pageNo = v
            this.getList()
        },
        getInfo() {
            insuranceBxCostsApprovalInfo({ auditMipId: this.fdId }).then(res => {
                if (res && +res.code === 0) {
                    this.info = res.data || {}
                }
            })
        },
        getList() {
            this.loading = true
            insuranceBxCostsApprovalPage({ auditMipId: this.fdId, pageNo: this.pageNo, pageSize: this.pageSize })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.tableData = (res.data.list || []).map(v => {
                            return {
                                ...v,
                                bpCustomerType_: this.dict['SRM_INSURANCE_IN_OR_OUT_CUSTOMER'][v.bpCustomerType],
                                bpCustomerCategory_:
                                    this.dict['SRM_INSURANCE_COUSTOMER_CATEGORY'][v.bpCustomerCategory],
                                bpStatus_: this.dict['SRM_INSURANCE_BP_STATUS'][v.bpStatus],
                                orderBusinessType_: this.dict['SYS_BUSINESS_CATEGORY'][v.orderBusinessType],
                                professionalCompany_: this.dict['SYS_PROFESSIONAL_COMPANY'][v.professionalCompany],
                            }
                        })
                        this.total = res.data.totalCount || 0
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
}
</script>
<style lang="less" scoped>
.progress-table {
    .mb10 {
        margin-bottom: 10px;
    }
    .mr50 {
        margin-right: 50px;
    }
}
</style>
